import { ShortSubRouteAttributes } from '@albatrosdeveloper/ave-models-package';
import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { getCode } from 'app/utils/method';

export type BusinesPartnerGeoDialogData = {
  subSroutes: ShortSubRouteAttributes[];
  subSroute: ShortSubRouteAttributes;
};

export type BusinesPartnerGeoDialogResult = ShortSubRouteAttributes;

@Component({
  selector: 'app-busines-partner-geo-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatDialogModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatButtonModule
  ],
  templateUrl: './busines-partner-geo-dialog.component.html',
  styleUrl: './busines-partner-geo-dialog.component.scss'
})
export class BusinesPartnerGeoDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: BusinesPartnerGeoDialogData,
    private dialogRef: MatDialogRef<BusinesPartnerGeoDialogComponent>
  ) {}

  
  form = new FormGroup({
    selectedSubRoute: new FormControl<ShortSubRouteAttributes | null>(null, Validators.required)
  })

  ngOnInit() {
    this.form.controls.selectedSubRoute.setValue(this.data.subSroute);
  }

  get selectedSubRoute(): ShortSubRouteAttributes | null {
    return this.form.getRawValue().selectedSubRoute;
  }

  getCode = getCode;

  onConfirm(): void {
    this.dialogRef.close(this.selectedSubRoute ?? null);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
